// extracted by mini-css-extract-plugin
export default {"fixIcon":"index_fixIcon_C6s3M","fixTopIcon":"index_fixTopIcon_UtFTR","fixBottomIcon":"index_fixBottomIcon_PX0wV"};